export const FB_UPDATE_STATE = "FB_UPDATE_STATE"
export const FB_UPDATE_MESSAGE = "FB_UPDATE_MESSAGE"
